import { useState } from "react";
import { Capacitor } from "@capacitor/core";
import { LoginToken } from "../Utility/common";
import HelpWantedModal from "./HelpWantedModal";
import { OffcanvasProvider, Trigger, Offcanvas } from "react-simple-offcanvas";

const returnFormattedDate = (d) => {
  const D = new Date(d);
  return `${D.getMonth() + 1}/${D.getDate()}/${D.getFullYear()}`;
};

const HelpWantedCard = (props) => {
  const { e, profiles, logInUsername } = props;
  const [activeCard, setActiveCard] = useState(null);

  const returnCard = () => {
    return (
      <div className="mb-3">
        <div
          className="mb-2"
          style={{
            padding: "1.25rem",
            display: "flex",
            flexDirection: "column",
            borderRadius: "0.5rem",
            backgroundColor: "white",
            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            height: "100%",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.475rem" }}
            >
              <div>
                <div
                  className="border"
                  style={{
                    overflow: "hidden",
                    borderRadius: "100%",
                    width: "2.25rem",
                    height: "2.25rem",
                  }}
                >
                  <img
                    alt=""
                    src={
                      e?.PrimaryLogoURL
                        ? e?.PrimaryLogoURL
                        : "https://framerusercontent.com/images/bmGWCOwjWg1eAyNB7Zi2RY3Bsg.png"
                    }
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
              <div style={{ fontSize: "14px" }}>
                Made by{" "}
                {e?.ConnectedPartnerName ? e?.ConnectedPartnerName : "Genni"}
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              marginTop: "0.75rem",
              paddingTop: "1.25rem",
              borderTop: "1px solid #f0f2f4",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "10rem",
                overflow: "hidden",
                borderRadius: "0.5rem",
                position: "relative",
                background: "#000",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: 1,
                  background:
                    "linear-gradient(to top, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
                }}
              />
              <img
                alt=""
                src={
                  e?.ExploreSurvey_ImageURLLocation || e?.SocialMedia_ImageURL
                }
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: `${
                    e?.ExploreSurvey_ImageURLLocation ? "cover" : "contain"
                  }`,
                  borderRadius: "0.375rem",
                }}
              />
            </div>

            <div style={{ width: "100%", marginTop: "1rem" }}>
              <div style={{ fontSize: "1.1rem", fontWeight: 600 }}>
                {e.ExploreSurveyTitle_ExternalPublic}
              </div>
              <div style={{ marginTop: "0.5rem", color: "#64748B" }}>
                {e.ExploreSurvey_HeaderOrListShortDescription}
              </div>
            </div>

            <div
              className="btn btn-light full-width"
              style={{ marginTop: "auto" }}
              onClick={()=>{
                if (!Capacitor.isNativePlatform()){
                  setActiveCard(e);
                }
              }}
            >
              Apply Now
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {Capacitor.isNativePlatform() ? (
        <>
          <OffcanvasProvider>
            <Trigger className="button-none-2">{returnCard()}</Trigger>

            <Offcanvas
              backdrop={false}
              title={e?.ExploreSurveyTitle_ExternalPublic}
              position="bottom"
              className="offcanvas-sub"
            >
              <HelpWantedModal
                profiles={profiles}
                activeCard={e}
                setActiveCard={setActiveCard}
                isModal={false}
                logInUsername={logInUsername}
              />
            </Offcanvas>
          </OffcanvasProvider>
        </>
      ) : (
        <>{returnCard()}</>
      )}
      {!Capacitor.isNativePlatform() && (
        <HelpWantedModal
          profiles={profiles}
          activeCard={activeCard}
          setActiveCard={setActiveCard}
          logInUsername={logInUsername}
        />
      )}
    </>
  );
};

export default HelpWantedCard;
